export const allowedOrigins = new Set(["https://ann-braintrust.web.app", "https://ann-braintrust-prod.web.app"])
